module.exports = __webpack_public_path__ + "static/media/businessman.250f3602.png";